<ng-container *ngIf="deviceType() === 'desktop'; else generalView">
  <ng-container *ngIf="navLink().children && isHavingIndexPage(navLink()); else noLink">
    <a [routerLink]="dotCMSHeaderNavigationLink(navLink().href)" (click)="hideFlyout(dropDownLayer())">
      {{ navLink().title }}</a
    >
  </ng-container>
  <ng-template #noLink>
    <div [class]="'disable-links' + depth()">{{ navLink().title }}</div>
  </ng-template>
</ng-container>
<ng-template #generalView>
  <ng-container *ngIf="navLink().children && isHavingIndexPage(navLink()); else noLink">
    <a
      [routerLink]="dotCMSHeaderNavigationLink(navLink().href)"
      class="main-navigation-link single-category-navigation"
      [ngClass]="{ 'without-sub-menu': !navLink().children }"
    >
      {{ navLink()?.title }}
    </a>
  </ng-container>
  <ng-template #noLink>
    <div class="mob-disable-links">{{ navLink()?.title }}</div>
  </ng-template>
</ng-template>
